/**
 * 外部サービス連携 コールバック処理
 */
import Vue from 'vue'
import * as httpConst from '../../../../constants/httpConst'
const API_PATH = `${httpConst.DRIVER_ENDPOINT}/providers`
const tenantProviderCallback = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    create ({ commit }, { provider, params }) {
      const api_path = `${API_PATH}/${provider}/callbacks`
      return new Promise((resolve) => {
        Vue.$http.post(api_path, params).then(data => {
          const result = data.result
          if (result.code === 20001) {
            commit('snackbar/showInfo', { message: '連携しました' }, { root: true })
          }
          resolve(data)
        })
      })
    },
  },
}
export default tenantProviderCallback
